import { ChainId } from '@pancakeswap/sdk'
import BigNumber from 'bignumber.js'
import { BIG_TEN } from 'utils/bigNumber'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BSC_BLOCK_TIME = 5

export const BASE_BSC_SCAN_URLS = {
  [ChainId.BSC]: 'https://bscscan.com',
  // [ChainId.ETH]: 'https://etherscan.io',
  // [ChainId.ARB]: 'https://arbiscan.io',
  // [ChainId.BASE]: 'https://basescan.org',
  // [ChainId.POLYGON]: 'https://polygonscan.com',
  [ChainId.BSC_TESTNET]: 'https://testnet.bscscan.com/',
  // [ChainId.BASE_SEPOLIA]: 'https://sepolia.basescan.org',
  // [ChainId.DAN]: 'https://danscan.io',
  // [ChainId.DANNY]: 'https://dannyscan.com',
}

// CAKE_PER_BLOCK details
// 40 SWAP is minted per block
// 20 SWAP per block is sent to Burn pool (A farm just for burning cake)
// 10 SWAP per block goes to SWAP syrup pool
// 9 SWAP per block goes to Yield farms and lottery
// CAKE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// SWAP/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const CAKE_PER_BLOCK = 14
export const BLOCKS_PER_YEAR = (60 / BSC_BLOCK_TIME) * 60 * 24 * 365 // 10512000
export const CAKE_PER_YEAR = CAKE_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = ''
export const BASE_ADD_LIQUIDITY_URL = `/add`
export const BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[ChainId.BSC]
export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18)
export const DEFAULT_GAS_LIMIT = 250000
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'
